export default "__VITE_ASSET__CHpzExbk__"